<template>
  <!-- On enleve le d-flex pour permettre le masquage (d-none) au niveau des row -->
  <!-- Des tests unitaires de non régression ont été effectués sur les pages du Formulaire -->
  <div
    :id="content.idHTML"
    class="flex-column"
    :class="[jel_getClassObject(content), { 'h-100': prendrePleineHauteur }]"
  >
    <EditableArea
      v-if="content.formatAffichage.field != 'carrousel'"
      class="row h-100"
      :class="content.gutters ? 'gutters-' + content.gutters : 'no-gutters'"
      :content="content.row"
      :parentTemplateId="metadata['mgnl:template']"
    >
    </EditableArea>
    <component
      :is="'carrousel'"
      v-if="content.formatAffichage.field == 'carrousel'"
      :key="content['@id']"
      :content="content"
      :metadata="metadata"
    >
    </component>
  </div>
</template>

<script>
import { EditableArea } from '@/vue-editor';
import Carrousel from '@/components/container/carrousel/Carrousel';

export default {
  name: 'Row',
  components: {
    EditableArea,
    Carrousel,
  },
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {};
  },
  computed: {
    prendrePleineHauteur() {
      return this.content.pleineHauteur == undefined || this.content.pleineHauteur == 'true';
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
  },
  methods: {
    getGutter(gutter) {
      let result;
      switch (gutter) {
        case 'xsmall':
          result = 'px-1';
          break;
        case 'small':
          result = 'px-2';
          break;
        case 'medium':
          result = 'px-3';
          break;
        case 'large':
          result = 'px-4';
          break;
        case 'xLarge':
          result = 'px-6';
          break;
        case 'xxLarge':
          result = 'px-8';
          break;
        case 'xxxLarge':
          result = 'px-10';
          break;
        default:
          result = 'px-0';
      }
      return result;
    },
    getWidth(carrouselSize) {
      let size;

      if (carrouselSize == 'FullScreen') {
        size = 'takeFullWidth';
      } else {
        size = '';
      }
      return size;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background-position: center;
  background-repeat: no-repeat;
}
.content.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}
.row-titre-promotions {
  background-color: #0c1a35;
  ::v-deep .tresGrandTitre {
    color: white;
  }
}
</style>
